'use strict'

const React = require('react')

const Xfade = require('../designtool/Xfade.jsx')

const Media = React.createClass({
    propTypes: {
        media: React.PropTypes.shape({
            filename: React.PropTypes.string,
            width: React.PropTypes.number,
            height: React.PropTypes.number,
            alt: React.PropTypes.string,
        }),

        // Used only for the resize query
        width: React.PropTypes.number,
        height: React.PropTypes.number,

        style: React.PropTypes.object,
        
        className: React.PropTypes.string,
        crossfade: React.PropTypes.bool,
    },
    render: function() {
        let w, h

        if (!this.props.width && !this.props.height) {
            w = this.props.media.width
            h = this.props.media.height
        }
        else if (this.props.width) {
            w = Math.round(Math.min(this.props.width, this.props.media.width))
            h = Math.round(this.props.media.height / this.props.media.width * w)
        }
        else {
            h = Math.round(Math.min(this.props.height, this.props.media.height))
            w = Math.round(h / (this.props.media.height / this.props.media.width))
        }

        const resize_query = w && h ? `r/${w}x${h}/` : ''
        const src = `${Payload.release.media}${resize_query}${this.props.media.filename}`
        const lg = `${Payload.release.media}${this.props.media.filename}`

        if (this.props.crossfade) {
            return <Xfade opacityStep = {0.05}
                          src         = {lg}
                          srcSet      = {`${lg}, ${src}`}
                          alt         = {this.props.media.alt}
                          className   = {this.props.className}
                          style       = {this.props.style} />
        }
        return (
            <img src       = {src}
                 srcSet    = {`${lg}, ${src}`}
                 alt       = {this.props.media.alt}
                 className = {this.props.className}
                 width={w}
                 height={h}
                 />

        );
    },
})

module.exports = Media



// WEBPACK FOOTER //
// ./src/components/media.jsx